<template>
    <section>

        <div class="page">
            <div>
                <h2>Connection problems</h2>
                <p>
                    If you can't connect to ToTok, this is usually caused by a problem with your Internet connection or
                    your phone's
                    settings.
                </p>
                <p>
                    Most connection issues can be resolved by doing the following:
                </p>
                <ul>
                    <li>
                        Restart your phone or turn it off and on.
                    </li>
                    <li>
                        Update ToTok to the latest version available from Google Play.
                    </li>
                    <li>
                        Open phone's <strong>Settings</strong> > tap <strong>Network & internet</strong> > turn Airplane
                        mode on and off.
                    </li>
                    <li>
                        Open phone's <strong>Settings</strong> > tap <strong>Network & internet</strong> > Data usage >
                        turn Mobile data on.
                    </li>
                    <li>
                        Open phone's <strong>Settings > Network & internet > Wi-Fi</strong> > turn Wi-Fi off and on.
                    </li>
                    <li>
                        Try connecting to different Wi-Fi hotspots.
                    </li>
                    <li>
                        Make sure Wi-Fi stays on during sleep mode.
                    </li>
                    <li>
                        Reboot your Wi-Fi router.
                    </li>
                    <li>
                        Contact your mobile provider and make sure your APN settings are configured correctly.
                    </li>
                    <li>
                        Upgrade or restore your phone's operating system to the latest version for your phone.
                    </li>
                    <li>
                        If you're having trouble connecting to ToTok while on a Wi-Fi network that you don't normally
                        connect to,
                        contact the network administrator.
                    </li>
                    <li>
                        If you're on a campus or corporate Wi-Fi that has firewall restrictions in place, contact the
                        network
                        administrator.
                    </li>
                    <li>
                        ToTok isn't designed to be used with proxy or VPN services, so we can't provide support for
                        those
                        configurations.
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
